import { ToastIcon, ToastOptions, toast } from 'react-toastify';

interface NotifyProps extends Omit<ToastOptions, 'icon'> {
  message: string;
  description?: string;
  duration?: number;
  icon?: ToastIcon | React.ReactNode;
}

interface UseNotificationInterface {
  notify: (props: NotifyProps) => void;
}

const useNotification = (): UseNotificationInterface => {
  const notify = ({
    message,
    description,
    icon,
    position = 'top-center',
    duration = 3,
    hideProgressBar = true,
    closeOnClick = true,
    pauseOnHover = true,
    type = 'default',
  }: NotifyProps) => {
    const normalizedIcon: ToastIcon | undefined = icon ? () => <>{icon}</> : undefined;

    const options: ToastOptions = {
      icon: normalizedIcon,
      autoClose: duration * 1000,
      position,
      closeOnClick,
      pauseOnHover,
      hideProgressBar,
      type,
    };

    toast(
      <div className="flex flex-col gap-y-1">
        <h6 className="font-medium text-brand-text-primary" style={{ fontFamily: 'DM Sans' }}>
          {message}
        </h6>
        {description && (
          <p className="text-sm text-muted-foreground" style={{ fontFamily: 'DM Sans' }}>
            {description}
          </p>
        )}
      </div>,
      options,
    );
  };

  return { notify };
};

export default useNotification;
